/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useResize } from '../../hooks'
import { SplashDesk, SplashMobile, HeaderLogo } from '../../components'
import { Container, ContainerLogo } from './index.styled'

const SplashSplit = () => {

  const [ screenActive, setScreenActive ] = useState('');
  const [ logoClass, setLogoClass ] = useState('');

  const isMobile = useResize().isMobile;
  const vh = useResize().vhMobile;

  const getLogoClass = () => {
    let logoClass = ''

    if(isMobile || screenActive === ''){
      logoClass = 'middle';
    } else {
      if(screenActive === 'amorin_wise') {
        logoClass = 'amorin';
      } else if(screenActive === 'wicanders') {
        logoClass = 'wicanders';
      }
    }

    return logoClass;
  }

  const handlerBackMobile = () => {
    if(isMobile) setScreenActive('');
  }

  const screenRender = () => {
    return isMobile ? 
        <SplashMobile active={screenActive} 
                      handleScreenActive={setScreenActive} /> : 
        <SplashDesk active={screenActive} 
                      handleScreenActive={setScreenActive}/>;
  }

  useEffect(() => {
    setLogoClass(getLogoClass());
  }, [screenActive])

  return (
    <Container vh={vh}>
      <ContainerLogo className={logoClass} screenSize={isMobile ? 'mobile' : 'md'} onClick={handlerBackMobile}>
        <HeaderLogo />
      </ContainerLogo>
      {screenRender()}
    </Container>
  )
}
  
export default SplashSplit;
